export default "__VITE_ASSET__JfJ04FfD__"